import type { Map } from './raw'

import { getPath } from '../helpers'

/*
 * Map helpers
 */

/**
 * Get part of object/array by path
 */
export const path =
  (pathToSearch: string[]): Map =>
  (object) =>
    getPath(object, pathToSearch)

/**
 * Wrap value to array, unless it is not array already
 */
export const array = <T>(value?: T | T[] | null): T[] | null => {
  if (value == null) return null
  return Array.isArray(value) ? value : [value]
}
